export const CHAT_BOT_INTERACTION = 'CHAT_BOT_INTERACTION';